var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLupIcon = function SvgLupIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0m1 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0M9.57 8.618v2.611c0 .311-.254.565-.564.565h-.282a.566.566 0 0 1-.565-.565V7.206H4.206L7.029 9.22v2.008c0 .858.696 1.553 1.553 1.553h.53a1.59 1.59 0 0 0 1.588-1.588V8.618zm3.954 0h-2.26v4.164h1.13v-1.34h1.13a1.27 1.27 0 0 0 1.27-1.271v-.283a1.27 1.27 0 0 0-1.27-1.27m.14 1.468a.484.484 0 0 1-.483.483h-.787V9.44h.787c.265 0 .484.215.484.484z",
    clipRule: "evenodd"
  })));
};
export default SvgLupIcon;